import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static values = {
    siblingFormSelector: String
  }

  connect() {
    this.form = this.element.querySelector("form")
    if (this.form) {
      this.boundCaptureFormState = this.captureFormState.bind(this)
      this.form.addEventListener("submit", this.boundCaptureFormState)
    }
  }

  disconnect() {
    if (this.form && this.boundCaptureFormState) {
      this.form.removeEventListener("submit", this.boundCaptureFormState)
    }
  }

  // Before submitting the coupon form, capture values from the sibling form
  // and add them as hidden fields so they persist after the page reload
  captureFormState() {
    if (!this.hasSiblingFormSelectorValue) return

    const siblingForm = document.querySelector(this.siblingFormSelectorValue)
    if (!siblingForm) return

    const formId = siblingForm.id

    // Fields to capture from the sibling form (text inputs, selects)
    const fieldsToCapture = [
      "full_name",
      "email_address",
      "billing_address_country_code"
    ]

    fieldsToCapture.forEach(fieldName => {
      // Find the input - could be inside the form OR outside with form attribute (HTML5)
      const input = siblingForm.querySelector(`[name*="[${fieldName}]"]`) ||
                    siblingForm.querySelector(`[name="${fieldName}"]`) ||
                    (formId && document.querySelector(`[form="${formId}"][name*="[${fieldName}]"]`)) ||
                    (formId && document.querySelector(`[form="${formId}"][name="${fieldName}"]`))

      if (input && input.value) {
        this.setHiddenField(fieldName, input.value)
      }
    })

    // Capture selected subscription_type_id from radio buttons (always inside the form)
    const selectedRadio = siblingForm.querySelector('input[name*="[subscription_type_id]"]:checked') ||
                          siblingForm.querySelector('input[name="subscription_type_id"]:checked')

    if (selectedRadio && selectedRadio.value) {
      this.setHiddenField("subscription_type_id", selectedRadio.value)
    }
  }

  setHiddenField(name, value) {
    let hiddenField = this.form.querySelector(`input[name="${name}"]`)
    if (!hiddenField) {
      hiddenField = document.createElement("input")
      hiddenField.type = "hidden"
      hiddenField.name = name
      this.form.appendChild(hiddenField)
    }
    hiddenField.value = value
  }
}
